import { Observable, OperatorFunction } from 'rxjs';
import { map } from 'rxjs/operators';
import { ClassConstructor } from 'class-transformer';
import { convertToModelsArray } from '../helpers/model-conversion/convert-to-models.array';

export function toModelsArray<T, R>(Model: ClassConstructor<R>): OperatorFunction<T[], R[]> {
  return (input$: Observable<T[]>): Observable<R[]> => input$.pipe(map((data: T[]): R[] => convertToModelsArray(data, Model)));
}
